import { render, staticRenderFns } from "./SmallCenteredCard.vue?vue&type=template&id=f6fd87d8&scoped=true&"
import script from "./SmallCenteredCard.vue?vue&type=script&lang=js&"
export * from "./SmallCenteredCard.vue?vue&type=script&lang=js&"
import style0 from "./SmallCenteredCard.vue?vue&type=style&index=0&id=f6fd87d8&scoped=true&lang=css&"
import style1 from "./SmallCenteredCard.vue?vue&type=style&index=1&id=f6fd87d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fd87d8",
  null
  
)

export default component.exports